/* * 202503251655066274021 97993定制，在打开快照的时候，如果有图片，需要在快找弹框附近右侧显示图片缩略图 */

<template>
  <div id="home_kz_img_wrap"></div>
</template>

<script>
export default {
  name: 'HomeKZImgWrap',
  mounted() {
    // 注册拖拽事件
    this.$nextTick(this.initGrag)
    // 注册图片点击事件
    $('#home_kz_img_wrap').on('click', '.aboutImg-item', function () {
      parent.showImg({
        data: $('#home_kz_img_wrap').get(0).imgData,
        index: $(this).index()
      })
    })
    $('#home_kz_img_wrap').on('click', '.l-dialog-home-kz-close', function () {
      top.hideHomeKZImg(true)
    })
    // onlyHide传true，只隐藏dom，不清除数据
    top.hideHomeKZImg = function (onlyHide) {
      $('#home_kz_img_wrap').hide()
      if (!onlyHide) {
        $('#home_kz_img_wrap').html('')
        $('#home_kz_img_wrap').get(0).imgData = []
      }
    }
    top.showHomeKZImg = function() {
      $('#home_kz_img_wrap').show()
    }
    // 注册window上的回调
    top.refreshHomeKZImg = function (opt) {
      opt = opt || {}
      var unit = opt.unit
      var bsite = opt.bsite
      console.log('unit', unit)
      $.javaAjax({
        type: 'POST',
        cache: true,
        url: '/quickFindResult/qUICKSERARCH_OTHER_DATE',
        data: { unit: unit, gettype: 6, bsite: bsite }, // gettype 快照中传6代表是获取运单图片
        error: function (XMLHttpRequest, textStatus, errorThrown) {
          // $.ligerDialog.error('获取选项卡信息失败:' + errorThrown)
          top.hideHomeKZImg()
        },
        success: function (result) {
          var userData = result.data || {}
          if (result.success) {
            var dt1 = userData.dt1 || []
            var htmlarr = []
            if (dt1 == null || dt1 == undefined || dt1.length <= 0) {
              top.hideHomeKZImg()
            } else {
              var FileServerUrl = getWebConfigSetting('File_ServerUrl') //图片服务器地址
              // 添加标题
              htmlarr.push(`
                <div class="home-kz-img-header">
                  <div class="l-dialog-winbtn l-dialog-close l-dialog-home-kz-close"></div>
                </div>
              `)
              htmlarr.push('<div class="aboutImg-item-wrap">')
              for (var i = 0; i < dt1.length; i++) {
                dt1[i].picpath = FileServerUrl + dt1[i].picpath
                htmlarr.push('<div class="aboutImg-item">')
                htmlarr.push('    <div class="aboutImg-item-img">')
                htmlarr.push('        <img src="' + dt1[i].picpath + '"  onerror=\'this.src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-errorImg.jpg";\'/>')
                htmlarr.push('    </div>')
                htmlarr.push('    <div class="aboutImg-item-content">')
                htmlarr.push('        <div class="aboutImg-item-part">')
                htmlarr.push('            <span class="aboutImg-label">类型：</span>')
                htmlarr.push('            <span>' + dt1[i].type + '</span>')
                htmlarr.push('        </div>')
                htmlarr.push('        <div class="aboutImg-item-part">')
                htmlarr.push('            <span class="aboutImg-label">上传人：</span>')
                htmlarr.push('            <span>' + dt1[i].man + '</span>')
                htmlarr.push('        </div>')
                htmlarr.push('        <div class="aboutImg-item-part">')
                htmlarr.push('            <span class="aboutImg-label">上传时间：</span>')
                htmlarr.push('            <span>' + dt1[i].picdate + '</span>')
                htmlarr.push('        </div>')

                htmlarr.push('        <div class="aboutImg-item-part">')
                htmlarr.push('            <span class="aboutImg-label">图片标题：</span>')
                htmlarr.push('            <span>' + dt1[i].imgtitle + '</span>')
                htmlarr.push('        </div>')

                htmlarr.push('        <div class="aboutImg-item-part">')
                htmlarr.push('            <span class="aboutImg-label">图片描述：</span>')
                htmlarr.push('            <span>' + dt1[i].imgsummary + '</span>')
                htmlarr.push('        </div>')
                htmlarr.push('    </div>')
                htmlarr.push('</div>')
              }
              htmlarr.push('</div')
            }
            $('#home_kz_img_wrap').html(htmlarr.join(''))
            // 动态调整zindex
            var zindex = $('.quickFindWin').css('z-index')
            $('#home_kz_img_wrap')
              .show()
              .css({
                'z-index': Number(zindex) >= 0 ? Number(zindex) + 1 : 15000
              })
            $('#home_kz_img_wrap').get(0).imgData = dt1
          } else {
            top.hideHomeKZImg()
          }
        }
      })
    }
  },
  methods: {
    initGrag() {
      // const draggable = document.getElementById('home_kz_img_wrap')
      // let isDragging = false
      // let offsetX, offsetY
      // // 鼠标按下事件
      // draggable.addEventListener('mousedown', function (event) {
      //   isDragging = true
      //   offsetX = event.clientX - draggable.getBoundingClientRect().right
      //   offsetY = event.clientY - draggable.getBoundingClientRect().top
      // })
      // // 鼠标移动事件
      // document.addEventListener('mousemove', function (event) {
      //   if (isDragging) {
      //     draggable.style.right = `${window.innerWidth - event.clientX - offsetX}px`
      //     draggable.style.top = `${event.clientY - offsetY}px`
      //   }
      // })
      // // 鼠标释放事件
      // document.addEventListener('mouseup', function () {
      //   if (isDragging) {
      //     isDragging = false
      //   }
      // })
    }
  }
}
</script>

<style lang="css">
#home_kz_img_wrap {
  position: fixed;
  display: none;
  flex-direction: column;
  width: 230px;
  height: 660px;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  padding: 0px 0px 6px 0px;
  box-sizing: border-box;
  background: #8d8d8d;
  z-index: 15000;
  left: calc(50% + 569px);
  top: calc(50% - 340px);
  /* cursor: move; */
}
.home-kz-img-header {
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  height: 26px;
  background: #3f5768;
  color: #fff;
}
.aboutImg-item-wrap {
  overflow-y: auto;
  overflow-x: hidden;
  width: 230px;
  height: 620px;
  padding: 26px 6px 0 6px;
}

.aboutImg-item {
  width: 100%;
  min-height: 194px;
  border: 1px solid #ccc;
  float: left;
  margin-bottom: 10px;
  margin-right: 10px;
  padding: 5px;
  box-sizing: border-box;
  background: #fff;
  cursor: pointer;
}

.aboutImg-item:hover {
  background: #e8e8e8;
}

.aboutImg-item:nth-child(5n) {
  margin-right: 0;
}

.aboutImg-item-img {
  height: 200px;
}

.aboutImg-item-img img {
  width: 100%;
  height: 100%;
}

.aboutImg-item-content {
  overflow: hidden;
  line-height: 24px;
  font-size: 12px;
}

.aboutImg-item-part {
  width: 100%;
  overflow: hidden;
}

.aboutImg-item-part > span {
  float: left;
}

.aboutImg-label {
  width: 60px;
  text-align: right;
}
.l-dialog-home-kz-close.l-dialog-close {
  position: absolute;
  right: 10px;
  top: 5px;
}
</style>
